export default {
  name: [],
  description: [],
  profileImage: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  contentHouseId: [],
}
